import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { fill: true },
  },
});

type InstagramProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function InstagramIcon({
  className,
  pathClassName = "stroke-teal-600",
  ...props
}: InstagramProps) {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M11.5 2.666h-7a2.667 2.667 0 00-2.667 2.667v5.333A2.667 2.667 0 004.5 13.333h7a2.667 2.667 0 002.667-2.667V5.333A2.667 2.667 0 0011.5 2.666z"
        stroke="#2C7A7B"
        strokeWidth={1.5}
        className={pathClassName}
      />
      <Path
        d="M8 10.834a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
        stroke="#2C7A7B"
        strokeWidth={1.5}
        className={pathClassName}
      />
      <Path
        d="M11.334 4.668h.333"
        stroke="#2C7A7B"
        strokeWidth={1.5}
        strokeLinecap="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default InstagramIcon;
